export default () => {
  console.log('INIT SWIPER');

  let swipers = document.querySelectorAll('.swiper');

  swipers.forEach((swiper) => {
    let columns = swiper.getAttribute('max-cols');
    if (!columns || columns === '') {
      columns = 3;
    }
    let swiperConfig = {
      loop: true,
      //mousewheel: true,
      pagination: {
        el: swiper.querySelector('.swiper-pagination'),
        clickable: true,
      },
      navigation: {
        nextEl: swiper.parentNode.querySelector('.swiper-button-next'),
        prevEl: swiper.parentNode.querySelector('.swiper-button-prev'),
      },
    };

    if (swiper.getAttribute('big-media') !== null) {
      swiperConfig.scrollbar = {
        el: '.swiper-scrollbar',
        draggable: true,
      };
    }
    if (swiper.getAttribute('feature-list') !== null) {
      swiperConfig.scrollbar = {
        el: '.swiper-scrollbar',
        draggable: true,
      };

      swiperConfig.loop = false;
      swiperConfig.slidesPerView = 1;
      swiperConfig.spaceBetween = 14 * 1.5;
      swiperConfig.breakpoints = {
        580: {
          slidesPerView: Math.min(2, columns), // Show 2 slides at a time on medium screens
          spaceBetween: 16 * 1.5,
        },
        980: {
          slidesPerView: columns, // Show 3 slides at a time on larger screens
          spaceBetween: 18 * 1.5,
        },
        1280: {
          slidesPerView: columns, // Show 3 slides at a time on larger screens
          spaceBetween: 20 * 1.5,
        },
      };
    } else if (swiper.getAttribute('event-list') !== null) {
      swiperConfig.scrollbar = {
        el: '.swiper-scrollbar',
        draggable: true,
      };
      swiperConfig.loop = false;
      swiperConfig.slidesPerView = 1;
      swiperConfig.spaceBetween = 14 * 1.5;
      swiperConfig.breakpoints = {
        580: {
          slidesPerView: Math.min(2, columns), // Show 2 slides at a time on medium screens
          spaceBetween: 16 * 1.5,
        },
        980: {
          slidesPerView: Math.min(3, columns), // Show 3 slides at a time on larger screens
          spaceBetween: 18 * 1.5,
        },
        1280: {
          slidesPerView: columns, // Show 3 slides at a time on larger screens
          spaceBetween: 20 * 1.5,
        },
      };
    } else if (swiper.getAttribute('articles-list') !== null) {
      swiperConfig.scrollbar = {
        el: '.swiper-scrollbar',
        draggable: true,
      };
      swiperConfig.loop = false;
      swiperConfig.slidesPerView = 1;
      swiperConfig.spaceBetween = 14 * 1.5;
      swiperConfig.breakpoints = {
        580: {
          slidesPerView: Math.min(2, columns), // Show 2 slides at a time on medium screens
          spaceBetween: 16 * 1.5,
        },
        980: {
          slidesPerView: columns, // Show 3 slides at a time on larger screens
          spaceBetween: 18 * 1.5,
        },
        1280: {
          slidesPerView: columns, // Show 3 slides at a time on larger screens
          spaceBetween: 20 * 1.5,
        },
      };
    } else if (swiper.getAttribute('card-list') !== null) {
      swiperConfig.slidesPerView = 1;
      swiperConfig.spaceBetween = 14 * 1.5;
      swiperConfig.breakpoints = {
        580: {
          slidesPerView: Math.min(2, columns), // Show 2 slides at a time on medium screens
          spaceBetween: 16 * 1.5,
        },
        980: {
          slidesPerView: columns, // Show 3 slides at a time on larger screens
          spaceBetween: 18 * 1.5,
        },
        1280: {
          slidesPerView: columns, // Show 3 slides at a time on larger screens
          spaceBetween: 20 * 1.5,
        },
      };
    } else if (swiper.getAttribute('people-list') !== null) {
      swiperConfig.slidesPerView = 1;
      swiperConfig.spaceBetween = 14 * 1.5;
      swiperConfig.breakpoints = {
        580: {
          slidesPerView: Math.min(2, columns), // Show 2 slides at a time on medium screens
          spaceBetween: 16 * 1.5,
        },
        980: {
          slidesPerView: columns, // Show 3 slides at a time on larger screens
          spaceBetween: 18 * 1.5,
        },
        1280: {
          slidesPerView: columns, // Show 3 slides at a time on larger screens
          spaceBetween: 20 * 1.5,
        },
      };
    } else if (swiper.getAttribute('logo-list') !== null) {
      swiperConfig.slidesPerView = swiper.getAttribute('sm');
      swiperConfig.spaceBetween = 14 * 1.5;
      swiperConfig.breakpoints = {
        580: {
          slidesPerView: Number(swiper.getAttribute('sm')), // Show 2 slides at a time on medium screens
          spaceBetween: 14 * 1.5,
        },
        768: {
          slidesPerView: Number(swiper.getAttribute('md')), // Show 3 slides at a time on larger screens
          spaceBetween: 16 * 1.5,
        },
        980: {
          slidesPerView: Number(swiper.getAttribute('lg')), // Show 3 slides at a time on larger screens
          spaceBetween: 18 * 1.5,
        },
        1280: {
          slidesPerView: Number(swiper.getAttribute('xl')), // Show 3 slides at a time on larger screens
          spaceBetween: 20 * 1.5,
        },
      };
    }
    new Swiper(swiper, swiperConfig);
  });
};
